<div
  class="pr-panel-header"
  [ngClass]="clazz"
  [hidden]="!title && !panelHeader.children.length"
>
  <div #panelHeader [hidden]="!panelHeader.children.length">
    <ng-content select="[panelHeader]"></ng-content>
  </div>
  @if (title) {
    <h3 [hidden]="panelHeader.children.length" [class]="titleClass">
      @if (icon) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      @if (img) {
        <img [src]="img" width="26px" />
      }
      {{ title }} <ng-content select="[headerTooltip]"></ng-content>
    </h3>
  }
  <div class="flex-auto text-right">
    <ng-content></ng-content>
  </div>
</div>
